

import { defineComponent } from 'vue'
import { Array, Note } from 'tonal'

import Octave from '../components/Octave.vue'

export default defineComponent({
  name: 'PianoKeyboard',
  components: {
    Octave,
  },
  props: {
    keyWidth: {
      type: Number,
      default: 40,
    },
    keyHeight: {
      type: Number,
      default: 150,
    },
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    tonic: {
      type: String,
      default: 'C4',
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    minOct: {
      type: Number,
      default: 3,
    },
    maxOct: {
      type: Number,
      default: 6,
    },
    note: {
      type: Object,
      default: () => {},
    },
    notes: {
      type: Object,
      default: () => {},
    },
    pcset: {
      type: Object,
      default: () => {},
    },
    chordType: {
      type: String,
      default: '',
    },
  },
  computed: {
    octs (): any {
      return Array.range(this.minOct, this.maxOct)
    },
    viewWidth (): number {
      return this.octs.length * 7 * this.keyWidth
    },
    newnotes (): object {
      return {
        tonic: this.tonic,
        names: (this.notes || []).reduce((index: any, note: number) => {
          const midiNote: number = Number(Note.midi(note))
          index[midiNote] = note
          return index
        }, {}),
      }
    },
  },
  methods: {
    handleClick (e: any): void {
      // e.preventDefault()
      // emitter.emit('tonicChange', (this.midi, this.notes.names[this.midi]))
      // this.$emit('tonicChange', (this.midi, this.notes.names[this.midi]))
    },
    toggleActive (e: any): void {
      // console.log('event', e.target)
      const elements = document.querySelectorAll('.card')
      /*
      Array.prototype.forEach.call(elements, function (el, i) {
        el.classList.remove('active')
      })
      */
      elements.forEach((el, i) => {
        el.classList.remove('active')
      })
      e.target.parentNode.parentNode.classList.add('active')
    },
  },
})
